export default "__VITE_ASSET__b1684ec2__"